<template>
  <div class="book-list" v-if="defaultShow">
    <div class="demo-book-box" v-for="(item, index) in dataList" :key="index">
      <div class="left-book" @click="toDetail(item.goodsId, item.goodsType, subjectId)">
        <el-image class="img_box" :src="item.cover">
          <div slot="error" class="image-slot">
            <img class="img_box" src="../assets/images/default_img.jpg" />
          </div>
        </el-image>
      </div>
      <div class="right-book-info">
        <div class="book-title">
          <div class="book-label" v-if="item.sourceFile">
            {{goodsTypeList.length > 0 ? callDictionaries(goodsTypeList, item.sourceFile) : item.sourceFile }}
          </div>
          <el-tooltip :content="item.goodsTitle" placement="top" v-ak-tooltip-auto-show>
            <div class="title" @click="toDetail(item.goodsId, item.goodsType, subjectId)">
              {{ item.goodsTitle }}
            </div>
          </el-tooltip>
        </div>
        <div class="author-p" v-if="item.goodsType == 'train'">
          讲师：{{item.lecturer == null || item.lecturer == "" ? "-" : item.lecturer }}
        </div>
        <div
          class="author-p"
          v-if="item.goodsType != 'paper' &&item.goodsType != 'looseleafOrtextbook' &&item.goodsType != 'train'">
          作者：{{item.author == null || item.author == "" ? "-" : item.author }}
        </div>
        <div class="author-p" v-if="item.goodsType != 'paper'">
          提供机构：{{item.instName == null || item.instName == "" ? "-" : item.instName }}
        </div>
        <div class="author-p" v-if="item.goodsType == 'paper'">
          考试时长：{{item.timeCount == null || item.timeCount == "" ? "-" : item.timeCount + "分钟" }}
        </div>
        <div class="author-p" v-if="item.goodsType == 'paper'">
          满分：{{item.fullScore == null || item.fullScore == "" ? "-" : item.fullScore + "分" }}
        </div>
        <div class="label" v-if="item.keyword != null">
          <span v-for="(item, index) in item.keyword.split(',')" :key="index" v-show="item">{{item }}</span>
        </div>
        <div class="price">
          <span>{{ item.realPrice | tofixed2("￥") }}</span>
          <span v-if="item.prices > 0" :class="item.prices == 0 ? 'yprice2' : 'yprice'">{{ item.prices | tofixed2("￥") }}</span>
        </div>
        <div class="editor-l" v-if="showEditor">编辑推荐语：</div>
        <p>{{item.authorRecommendation == null || item.authorRecommendation == "" ? "" : item.authorRecommendation }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyWord: [],
      defaultShow: true,
    };
  },
  props: {
    dataList: Array,
    // call:Boolean,
    showBook: Boolean,
    subjectId: String,
    showEditor: Boolean,
    payType: String,
    goodsTypeList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    showBook() {
      //专题详情图书的收起
      this.defaultShow = this.showBook;
    },
  },
  methods: {
    toDetail(id, type, id2) {
      if (type == "train") {
        let routeUrl = this.$router.resolve({
          path: "/willingLearn/bookstoreDetail",
          query: {
            goodsId: id,
            goodsType: "train",
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/bookstore/bookstoreDetail",
          query: {
            goodsId: id,
            goodsType: type,
            subjectId: id2,
            payType: this.payType,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.book-list {
  margin-top: 15px;
  .demo-book-box {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 15px;
    .left-book {
      width: 260px;
      height: 260px;
      background: #fbfbfb;
      border: 1px solid #f2f2f2;
      border-radius: 6px;
      margin-right: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        // max-width: 100%;
        // max-height: 100%;
        // object-fit: scale-down;
      }
    }
    .right-book-info {
      width: 750px;
      .book-title {
        display: flex;
        align-items: center;
        height: 24px;
        margin-bottom: 20px;
        .book-label {
          // width: 60px;
          padding: 0 15px;
          height: 24px;
          background: #f9fdff;
          border: 1px solid #0081ce;
          border-radius: 6px;
          text-align: center;
          line-height: 24px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          margin-right: 10px;
          box-sizing: border-box;
        }
        .title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          max-width: 600px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .title:hover {
          color: #1690ff;
          text-decoration: underline;
        }
      }
      .author-p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 14px;
      }
      .label {
        display: flex;
        align-items: center;
        margin-bottom: 29px;
        flex-wrap: wrap;
        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          background: #f2f2f2;
          border-radius: 6px;
          padding: 7px 10px;
          margin-right: 16px;
          box-sizing: border-box;
          display: block;
          margin-bottom: 8px;
        }
        span:last-child {
          margin-right: 0;
        }
      }
      .price {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ff5353;
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        .yprice {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          text-decoration: line-through;
          color: #999999;
          margin-left: 10px;
        }
        .yprice2 {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          text-decoration: line-through;
          margin-left: 10px;
        }
      }
      .editor-l {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 14px;
      }
      p {
        width: 750px;
        font-size: 14px;
        line-height: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /*行数*/
        -webkit-box-orient: vertical;
      }
    }
  }
  .demo-book-box:last-child {
    margin: 0;
    border: none;
    padding: 0;
  }
}
.img_box {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: cover;
  background: #fff;
}
</style>
